export const JOURNEY_PARAMS="COMMONSEO/JOURNEY_PARAMS"